import React from 'react';
import './CardCursosHabilitados.css';
import { Link } from 'react-router-dom';

import imgCaja from '../../../assets/img/cursos/curso/curso.1.jpeg';
import imgManualidades from '../../../assets/img/cursos/curso/manualidades.jpeg';
import ofimatica from '../../../assets/img/cursos/curso/ofimatica.jpeg';
const cursos = [
  {
    title: 'Caja Registradora Sistematizada',
    text: 'Aprende el manejo de sistemas de facturación con herramientas digitales.',
    image: imgCaja,
    alt: 'Afiche del curso Caja Registradora Sistematizada',
    to: '/cursos/caja-registradora-sistematizada',
  },
  {
    title: 'Manualidades Creativas',
    text: 'Desarrolla creatividad y habilidades manuales para proyectos decorativos.',
    image: imgManualidades,
    alt: 'Afiche del curso de Manualidades creativas',
    to: '/cursos/manualidades-creativas',
  },

  {
    title: 'Ofimatica Basica',
    text: 'Aprende lo esencial para estudiar y trabajar',
    image: ofimatica,
    alt: 'Afiche del curso de Manualidades creativas',
    to: '/cursos/ofimatica',
  },
];

const CardCursosHabilitados = () => {
  return (
    <section className="cursos-hab" id="cursos" aria-labelledby="cursos-hab-title">
      <h2 id="cursos-hab-title" className="cursos-hab__title">
        Cursos Habilitados
      </h2>

      <div className="cursos-hab__grid">
        {cursos.map((curso) => (
          <article key={curso.title} className="curso-card">
            <div className="curso-card__media">
              <img src={curso.image} alt={curso.alt} className="curso-card__img" />
            </div>

            <div className="curso-card__body">
              <h3 className="curso-card__name">{curso.title}</h3>
              <p className="curso-card__text">{curso.text}</p>
              <Link className="curso-card__btn" to={curso.to}>
                Ver Programa
              </Link>

            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default CardCursosHabilitados;